import pendingBcrActionTypes from "../actions/types/pendingBcr.action.type";

export const pendingBcrInitialState = {
  pendingBcrData: null,
  totalCount: 0,
  pendingBcrError: null,
  searchValues: null,
  approveRejectBcrData: null,
  approveRejectBcrError: null,
};

export default function pendingBcrReducer(state = pendingBcrInitialState, action) {
  switch (action.type) {
    case pendingBcrActionTypes.GET_PENDING_BCR_APPROVALS_SUCCESS:
      return {
        ...state,
        pendingBcrData: action.data,
        totalCount: action.totalCount || 0,
        searchValues: action.searchValues,
        pendingBcrError: null,
      };

    case pendingBcrActionTypes.GET_PENDING_BCR_APPROVALS_FAILURE:
      return {
        ...state,
        pendingBcrData: null,
        pendingBcrError: action.error,
      };

    case pendingBcrActionTypes.APPROVE_REJECT_PENDING_BCR_SUCCESS:
      return {
        ...state,
        approveRejectBcrData: action.data,
        approveRejectBcrError: null,
      };

    case pendingBcrActionTypes.APPROVE_REJECT_PENDING_BCR_FAILURE:
      return {
        ...state,
        approveRejectBcrData: null,
        approveRejectBcrError: action.error,
      };

    default:
      return state;
  }
}
